  (function() {
    var cd = document.getElementById('rrmw-countdown');
    if (!cd) return;
    var endDate = new Date(cd.dataset.end);
    if (isNaN(endDate)) return;

    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = endDate - new Date();
      if (diff <= 0) {
        cd.querySelectorAll('[data-unit]').forEach(function(el){ el.textContent = '00'; });
        return;
      }
      var days  = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins  = Math.floor((diff % 3600000) / 60000);
      var secs  = Math.floor((diff % 60000) / 1000);
      cd.querySelector('[data-unit="days"]').textContent    = pad(days);
      cd.querySelector('[data-unit="hours"]').textContent   = pad(hours);
      cd.querySelector('[data-unit="minutes"]').textContent = pad(mins);
      cd.querySelector('[data-unit="seconds"]').textContent = pad(secs);
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* === CAROUSELS (hero + prize gallery) === */
  document.querySelectorAll('.rrmw-carousel').forEach(function(root) {
    var slides = root.querySelectorAll('.hero-slide');
    var dots   = root.querySelectorAll('.hero-dot');
    var prevBtn = root.querySelector('.hero-arrow-prev');
    var nextBtn = root.querySelector('.hero-arrow-next');
    if (!slides.length) return;

    var current = 0;
    var total   = slides.length;
    var autoplayMs = parseInt(root.dataset.autoplayMs, 10) || 3000;
    var timer = null;
    var paused = false;

    function go(idx) {
      idx = ((idx % total) + total) % total; // wrap
      slides.forEach(function(s, i) {
        var active = (i === idx);
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function(d, i) {
        var active = (i === idx);
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      current = idx;
    }

    function next() { go(current + 1); }
    function prev() { go(current - 1); }

    function startAuto() {
      stopAuto();
      if (paused || total < 2) return;
      timer = setInterval(next, autoplayMs);
    }
    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function resetAuto() { startAuto(); }

    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); resetAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { next(); resetAuto(); });

    dots.forEach(function(d) {
      d.addEventListener('click', function() {
        var idx = parseInt(d.dataset.goSlide, 10) || 0;
        go(idx);
        resetAuto();
      });
    });

    // Pause on hover (desktop) and on focus-within (keyboard)
    root.addEventListener('mouseenter', function() { paused = true; stopAuto(); });
    root.addEventListener('mouseleave', function() { paused = false; startAuto(); });
    root.addEventListener('focusin',    function() { paused = true; stopAuto(); });
    root.addEventListener('focusout',   function() {
      // delay so quickly tabbing through doesn't restart instantly
      setTimeout(function() {
        if (!root.contains(document.activeElement)) { paused = false; startAuto(); }
      }, 50);
    });

    // Pause when tab is hidden, resume when visible
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) { stopAuto(); }
      else if (!paused) { startAuto(); }
    });

    // Basic touch swipe (mobile)
    var touchStartX = null;
    root.addEventListener('touchstart', function(e) {
      if (e.touches && e.touches[0]) touchStartX = e.touches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function(e) {
      if (touchStartX == null) return;
      var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : touchStartX;
      var dx = endX - touchStartX;
      if (Math.abs(dx) > 40) {
        if (dx < 0) next(); else prev();
        resetAuto();
      }
      touchStartX = null;
    }, { passive: true });

    // Respect reduced-motion: don't autoplay
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Skip autoplay; user can still use arrows/dots.
    } else {
      startAuto();
    }
  });
